import React, { useState } from 'react'
import { getServiceRequestFields } from './serviceRequestFields'
import { Label } from '~/lib/ui/label'
import { Textarea } from '~/lib/ui/textarea'
import { Input } from '~/lib/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '~/lib/ui/select'
import { Checkbox } from '~/lib/ui/checkbox'
import UploadCandidateResume from './UploadCandidateResume'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '~/lib/ui/dialog'
import { Button } from '~/lib/ui/button'
import { useToast } from '~/lib/ui/toast'
import { useServiceRequest } from './ServiceRequestDetail'
import { apiPost } from '~/util/api'
import { useMutation } from '@tanstack/react-query'
import { InlineWidget, useCalendlyEventListener } from 'react-calendly'
import { queryClient, useCandidate } from './CandidateProvider'
import { updateLocationDetailItemId } from './calendlyMutations'
import { Chrome } from '@uiw/react-color'

const ServiceRequestSelectInput = ({ formField, value, onChange }) => (
  <div className="py-4">
    <Label htmlFor={formField.column}>{formField.name}</Label>
    <Select id={formField.column} onValueChange={onChange} value={value}>
      <SelectTrigger>
        <SelectValue placeholder="Select An Option" />
      </SelectTrigger>
      <SelectContent>
        {formField.choices.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
)

const ServiceRequestTextareaInput = ({
  formField,
  formValues,
  setFormValues,
}) => (
  <div className="py-4">
    <Label htmlFor={formField.column}>{formField.name}</Label>
    <Textarea
      id={formField.column}
      value={formValues[formField.column] || ''}
      onChange={(e) => {
        setFormValues((prevValues) => ({
          ...prevValues,
          [formField.column]: e.target.value,
        }))
      }}
    />
  </div>
)

const SALARIES = [
  'Under $50,000',
  '$50,000 - $75,000',
  '$75,000 - $100,000',
  '$100,000 - $125,000',
  'More than $125,000',
]

// const SECTORS = [
//   { value: 'Any', label: 'Any' },
//   { value: 'Public', label: 'Public' },
//   { value: 'Private', label: 'Private' },
// ]

// const COMPANY_SIZES = [
//   { label: 'Less than 10 employees', value: 1 },
//   { label: '10 - 100 employees', value: 2 },
//   { label: '100 - 500 employees', value: 3 },
//   { label: '500 - 1000 employees', value: 4 },
//   { label: '1000 - 5000 employees', value: 5 },
//   { label: 'More than 5000 employees', value: 6 },
// ]

const InitiateServiceRequestForm = ({
  requestType,
  setFormValues,
  ...props
}) => {
  // const { industries, companySizes } = useCandidate()
  // const formFields =
  //   getServiceRequestFields(industries, companySizes, SALARIES)[requestType] ||
  //   []
  const messageField = {
    column: 'message',
    name: 'Additional Information',
  }
  return (
    <div>
      <div className="subtitle">Service Request Details</div>
      {/* {formFields.map((formField, idx) => (
        <ServiceRequestInput
          key={`formField-${idx}`}
          formField={formField}
          setFormValues={setFormValues}
          formValues={props.formValues}
          {...props}
        />
      ))} */}
      {/* extra columns based on targeted_research_type */}
      {/* {props.formValues?.targeted_research_type === 'company' && (
        <>
          <ServiceRequestInput
            formField={{ column: 'industry', name: 'Industry', type: 'input' }}
            setFormValues={setFormValues}
            formValues={props.formValues}
            {...props}
          />
          <ServiceRequestInput
            formField={{
              column: 'industry_2',
              name: 'Industry 2',
              type: 'input',
            }}
            setFormValues={setFormValues}
            formValues={props.formValues}
            {...props}
          />
          <ServiceRequestSelectInput
            formField={{ column: 'sector', name: 'Sector', choices: SECTORS }}
            setFormValues={setFormValues}
            formValues={props.formValues}
            {...props}
          />
          <ServiceRequestInput
            formField={{
              column: 'example_job_1',
              name: 'Example Job 1',
              type: 'input',
            }}
            setFormValues={setFormValues}
            formValues={props.formValues}
            {...props}
          />
          <ServiceRequestInput
            formField={{
              column: 'example_job_2',
              name: 'Example Job 2',
              type: 'input',
            }}
            setFormValues={setFormValues}
            formValues={props.formValues}
            {...props}
          />
          <ServiceRequestSelectInput
            formField={{
              column: 'company_size',
              name: 'Company Size',
              choices: COMPANY_SIZES,
            }}
            setFormValues={setFormValues}
            formValues={props.formValues}
            {...props}
          />
          <ServiceRequestInput
            formField={{ column: 'location', name: 'Location', type: 'input' }}
            setFormValues={setFormValues}
            formValues={props.formValues}
            {...props}
          />
        </>
      )}
      {['industry', 'both'].includes(
        props.formValues?.targeted_research_type,
      ) && (
        <>
          <ServiceRequestInput
            formField={{ column: 'industry', name: 'Industry', type: 'input' }}
            setFormValues={setFormValues}
            formValues={props.formValues}
            {...props}
          />
          <ServiceRequestInput
            formField={{
              column: 'industry_2',
              name: 'Industry 2',
              type: 'input',
            }}
            setFormValues={setFormValues}
            formValues={props.formValues}
            {...props}
          />
          <ServiceRequestSelectInput
            formField={{ column: 'sector', name: 'Sector', choices: SECTORS }}
            setFormValues={setFormValues}
            formValues={props.formValues}
            {...props}
          />
          <ServiceRequestInput
            formField={{
              column: 'example_company_1',
              name: 'Example Company 1',
              type: 'input',
            }}
            setFormValues={setFormValues}
            formValues={props.formValues}
            {...props}
          />
          <ServiceRequestInput
            formField={{
              column: 'example_company_2',
              name: 'Example Company 2',
              type: 'input',
            }}
            setFormValues={setFormValues}
            formValues={props.formValues}
            {...props}
          />
          <ServiceRequestSelectInput
            formField={{
              column: 'company_size',
              name: 'Company Size',
              choices: COMPANY_SIZES,
            }}
            setFormValues={setFormValues}
            formValues={props.formValues}
            {...props}
          />
          <ServiceRequestInput
            formField={{ column: 'location', name: 'Location', type: 'input' }}
            setFormValues={setFormValues}
            formValues={props.formValues}
            {...props}
          />
        </>
      )} */}
      <ServiceRequestInput
        formField={messageField}
        setFormValues={setFormValues}
        formValues={props.formValues}
        {...props}
      />
    </div>
  )
}
export default InitiateServiceRequestForm

const ServiceRequestInput = ({ formField, setFormValues, formValues }) => {
  const handleValueChange = (value) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [formField.column]: value,
    }))
  }
  if (formField.type === 'input')
    return (
      <div className="py-4">
        <Label htmlFor={formField.column}>{formField.name}</Label>
        <Input
          id={formField.column}
          value={formValues[formField.column] || ''}
          onChange={(e) => {
            setFormValues((prevValues) => ({
              ...prevValues,
              [formField.column]: e.target.value,
            }))
          }}
        />
      </div>
    )
  if (['resume_document_id', 'candidate_document'].includes(formField.column))
    return (
      <div className="py-4">
        <Label htmlFor={formField.column}>{formField.name}</Label>

        <UploadCandidateResume
          id={formField.column}
          setUploadedResumeId={(documentId) => {
            setFormValues((prevValues) => ({
              ...prevValues,
              resume_document_id: documentId,
            }))
          }}
        />
      </div>
    )
  if (formField.column === 'meeting_via_calendly')
    return (
      <div className="py-4">
        <Label htmlFor={formField.column}>{formField.name}</Label>
        <Checkbox
          id={formField.column}
          checked={formValues[formField.column] || false}
          onCheckedChange={handleValueChange}
        />
      </div>
    )
  if (formField.choices)
    return (
      <ServiceRequestSelectInput
        formField={formField}
        value={formValues[formField.column] || ''}
        onChange={handleValueChange}
      />
    )
  if (formField.type === 'color') {
    const DEFAULT_PRIMARY = '#1a237e'
    const DEFAULT_SECONDARY = '#616161'
    const colors = formValues.colors || {}
    return (
      <div className="py-4">
        <Label htmlFor={formField.column}>{formField.name}</Label>
        <div className="flex flex-col gap-4 md:flex-row md:gap-20">
          <div className="flex flex-col gap-2">
            <label htmlFor="primary-color-picker" className="font-medium">
              Primary Color
            </label>
            <Chrome
              color={colors.primary || DEFAULT_PRIMARY}
              onChange={(color) => {
                setFormValues((prevValues) => ({
                  ...prevValues,
                  colors: {
                    ...prevValues.colors,
                    primary: color.hex,
                  },
                }))
              }}
              className="!w-full md:!w-60"
            />
          </div>
          <div className="flex flex-col gap-2">
            <label htmlFor="secondary-color-picker" className="font-medium">
              Secondary Color
            </label>
            <Chrome
              color={colors.secondary || DEFAULT_SECONDARY}
              onChange={(color) => {
                setFormValues((prevValues) => ({
                  ...prevValues,
                  colors: {
                    ...prevValues.colors,
                    secondary: color.hex,
                  },
                }))
              }}
              className="!w-full md:!w-60"
            />
          </div>
        </div>
      </div>
    )
  }

  return (
    <ServiceRequestTextareaInput
      formField={formField}
      formValues={formValues}
      setFormValues={setFormValues}
    />
  )
}

export const InitiateServiceRequestDialog = ({
  children,
  initiationMode = 'meeting',
  ...props
}) => {
  const [open, setOpen] = useState(false)
  const [formValues, setFormValues] = useState({})
  const [selectedMeetingDuration, setSelectedMeetingDuration] = useState(50)
  const currentServiceRequest = useServiceRequest()
  const displayName = currentServiceRequest?.displayName || 'Resume Review'
  const [showScheduling, setShowScheduling] = useState(false)
  const researchQueueTypes = [
    'ServiceRequest::TargetCompanyResearch',
    'ServiceRequest::TargetedResearch',
    'ServiceRequest::SalaryResearch',
    'ServiceRequest::BusinessCardCreation',
  ]
  const { candidateId, idRef, industries, companySizes } = useCandidate()
  const { toast } = useToast()
  const isResearchQueueType = researchQueueTypes.includes(
    currentServiceRequest?.requestType,
  )
  const isGeneralCheckIn =
    currentServiceRequest?.requestType === 'ServiceRequest::GeneralCheckIn'
  const isElectronicInitiation = initiationMode === 'electronic'

  // Reset formValues when dialog is opened
  const handleDialogOpenChange = (newOpen) => {
    setOpen(newOpen)
    if (newOpen) {
      setSelectedMeetingDuration(50)
      const formFields =
        getServiceRequestFields(industries, companySizes, SALARIES)[
          currentServiceRequest?.requestType
        ] || []
      const initialValues = {}
      formFields.forEach((field) => {
        initialValues[field.column] = ''
      })
      initialValues['message'] = ''
      setFormValues(initialValues)
    }
  }

  const createServiceRequestMutation = useMutation({
    mutationFn: async () => {
      const data = {
        request_format: 'json',
        service_request: {
          type:
            currentServiceRequest?.requestType ||
            'ServiceRequest::ResumeReview',
          ...formValues,
          ...(isElectronicInitiation ? { meeting_via_calendly: false } : {}),
          candidate_id: candidateId,
        },
      }
      const response = await apiPost(
        '/coach/create_service_request',
        data,
        true,
      )
      return response
    },
    onSuccess: (response) => {
      setOpen(false)
      queryClient.invalidateQueries(['serviceRequests', candidateId])
      if (idRef) {
        idRef.current = response.data.service_request.id
      }
      const newId = response.data?.service_request?.id
      if (newId) updateLocationDetailItemId(newId)
      toast({
        title: 'Success',
        description: `${displayName} Request Saved`,
      })
    },
    onError: (error) => {
      console.error(`Error saving ${displayName} request:`, error)
      toast({
        title: 'Error',
        description: `Failed to save ${displayName} request`,
        variant: 'destructive',
      })
    },
  })

  return (
    <Dialog
      open={open}
      onOpenChange={handleDialogOpenChange}
      className="rounded-2xl"
    >
      <DialogTrigger asChild className="cursor-pointer">
        {children}
      </DialogTrigger>
      <DialogContent
        className="font-roboto lg:max-w-xl xl:max-w-3xl"
        variant="default"
        dialogCloseClass="text-black"
      >
        <DialogHeader>
          <DialogTitle>
            {' '}
            Open {displayName} Request on Behalf of Candidate
          </DialogTitle>
        </DialogHeader>
        <div className="max-h-[80vh] overflow-y-auto px-4 pb-4">
          <InitiateServiceRequestForm
            setFormValues={setFormValues}
            formValues={formValues}
            {...props}
          />
          {isResearchQueueType ? (
            <Button
              onClick={() => createServiceRequestMutation.mutate()}
              disabled={
                createServiceRequestMutation.isLoading ||
                (currentServiceRequest.requestType ===
                  'ServiceRequest::TargetedResearch' &&
                  formValues.targeted_research_type === undefined)
              }
            >
              {createServiceRequestMutation.isLoading
                ? 'Saving...'
                : 'Create Service Request'}
            </Button>
          ) : isElectronicInitiation ? (
            <Button
              onClick={() => createServiceRequestMutation.mutate()}
              disabled={createServiceRequestMutation.isLoading}
            >
              {createServiceRequestMutation.isLoading
                ? 'Saving...'
                : 'Create Service Review'}
            </Button>
          ) : showScheduling ? (
            <ScheduleCalendlyEvent
              formValues={formValues}
              setOpen={setOpen}
              selectedMeetingDuration={selectedMeetingDuration}
              setShowScheduling={setShowScheduling}
            />
          ) : (
            <div className="space-y-4">
              {isGeneralCheckIn && (
                <div className="flex flex-col gap-2 md:flex-row md:gap-4">
                  <Button
                    onClick={() => {
                      setSelectedMeetingDuration(30)
                      setShowScheduling(true)
                    }}
                  >
                    Schedule 30 Minute Meeting
                  </Button>
                  <Button
                    onClick={() => {
                      setSelectedMeetingDuration(50)
                      setShowScheduling(true)
                    }}
                  >
                    Schedule 50 Minute Meeting
                  </Button>
                </div>
              )}
              {!isGeneralCheckIn && (
                <Button onClick={() => setShowScheduling(true)}>
                  Schedule Meeting
                </Button>
              )}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}

const ScheduleCalendlyEvent = ({
  formValues,
  selectedMeetingDuration,
  setOpen,
}) => {
  const {
    candidateId,
    coachCalendlyLink,
    candidateName,
    candidateEmail,
    coachId,
    idRef,
  } = useCandidate()
  const currentServiceRequest = useServiceRequest()
  const requestType = currentServiceRequest?.requestType
  const displayName = currentServiceRequest?.displayName || 'Resume Review'
  const { toast } = useToast()
  const thirtyMinTypes = [
    'ServiceRequest::NetworkingStrategy',
    'ResumeRevision::CandidateRevision',
    'ServiceRequest::ExecutiveBio',
    'ServiceRequest::RecruiterGuidanceSupport',
    'ServiceRequest::BoardSearch',
    'ServiceRequest::JobSearchBurnout',
    'ServiceRequest::ResumeTailoring',
    'ServiceRequest::ResumeWriting',
    'ServiceRequest::NegotiationStrategy',
    'ServiceRequest::CoverLetterReview',
    'ServiceRequest::OnboardingSupport',
  ]
  // needs to be updated to handle first onboarding support
  const firstOnboardingSupport =
    requestType === 'ServiceRequest::OnboardingSupport'

  const isGeneralCheckIn = requestType === 'ServiceRequest::GeneralCheckIn'
  let meetingDuration = 50
  if (isGeneralCheckIn) {
    meetingDuration = selectedMeetingDuration || 50
  } else if (thirtyMinTypes.includes(requestType) && !firstOnboardingSupport) {
    meetingDuration = 30
  }

  const calendlyEventMutation = async (payload) => {
    const calendlyId = payload.event.uri.split('/').pop()
    const calendlyUserId = payload.invitee.uri.split('/').pop()
    const data = {
      request_format: 'json',
      calendly_event: {
        candidate_id: candidateId,
        coach_id: coachId,
        calendly_id: calendlyId,
        calendly_user_id: calendlyUserId,
        service_request_type: requestType || 'ServiceRequest::ResumeReview',
        service_request_data: {
          ...formValues,
          coach_started: true,
        },
      },
    }

    const response = await apiPost('/calendly_events.json', data, true)
    return response
  }

  const createCalendlyEventMutation = useMutation({
    mutationFn: calendlyEventMutation,
    onSuccess: (response) => {
      setOpen(false)
      queryClient.invalidateQueries(['serviceRequests', candidateId])
      if (idRef) {
        idRef.current = response.data.service_request.id
      }
      const newId = response.data?.service_request?.id
      if (newId) updateLocationDetailItemId(newId)
      toast({
        title: 'Success',
        description: `${displayName} Request Saved`,
      })
    },
    onError: (error) => {
      console.error(`Error saving ${displayName} request:`, error)
      toast({
        title: 'Error',
        description: `Failed to save ${displayName} request`,
        variant: 'destructive',
      })
    },
  })

  useCalendlyEventListener({
    onEventScheduled: (e) => {
      const payload = e.data.payload
      createCalendlyEventMutation.mutate(payload)
    },
  })

  return (
    <InlineWidget
      url={`${coachCalendlyLink}/${meetingDuration}min`}
      prefill={{
        name: candidateName,
        email: candidateEmail,
      }}
    />
  )
}
